import styled from 'styled-components';

export const Label = styled.div`
  line-height: 32px;
`;
